import type { LastCustomerOrder } from "@jti/store/slices/magentoApiSlice";

export type LastOrderAttribute = NonNullable<LastCustomerOrder>["additional_attributes"][number];
